const dt = new Date();

export default {
  id: {
    dbKey: 'id',
    type: 'string',
    displayName: 'ID',
    validationRules: [
      value => (!!value || value === '') || 'Required.',
    ],
  },
  name: {
    dbKey: 'name',
    type: 'string',
    displayName: 'Customer name',
    validationRules: [
      value => (!!value || (value && false)) || 'Required.',
      value => (value && value.length <= 32) || 'Max 32 characters',
    ],
  },
  code: {
    dbKey: 'code',
    type: 'string',
    displayName: 'Customer code',
    validationRules: [
      value => (!!value || (value && false)) || 'Required.',
      value => (value && value.length <= 32) || 'Max 32 characters',
    ],
  },
  logo: {
    dbKey: 'logo',
    type: 'file',
    displayName: 'Logo URL',
    validationRules: [
      value => (value && value.size < 2000000) || 'Logo size should be less than 2 MB!',
    ],
  },
  timestamp: {
    dbKey: 'timestamp',
    type: 'string',
    displayName: 'Timestamp',
    validationRules: [],
  },
  mock: {
    id: '',
    name: '',
    code: '',
    logo: null,
    timestamp: dt.toISOString(),
  },
};
